import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Circle, Container, Flex, Grid, Link, Stack, Text, List, ListItem, Heading } from '@chakra-ui/react';
import { Area, GET_STATIC_CONTENT, HeaderLinks, UserRoles, SITE_LEISURE, FS_DISPLAY_GUEST_ACCOUNT, FT_CCUI_UNIQUE_PROMO_CODE, Channel, MemoModalVariants } from '@whitbread-eos/api';
import { Icon, LanguageSelectorSwitcher, Logo, Popover } from '@whitbread-eos/atoms';
import { useCustomLocale, formatAssetsUrl, useQueryRequest, useAgentMemo, useFeatureSwitch, useHotelBrands, useFeatureToggle, isPromoAdmin, formatDataTestId } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState, useCallback, createElement as _createElement } from 'react';
import { ChangeLog } from '../../index';
import { getListOfLanguagesForSwitcher } from '../helpers/helpers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderAgent(_ref) {
  var _data$headerInformati, _data$headerInformati2, _data$headerInformati3, _data$headerInformati5, _data$headerInformati6, _data$headerInformati7, _data$headerInformati8, _data$headerInformati9, _data$headerInformati0;
  var roles = _ref.roles,
    user = _ref.user,
    queryClient = _ref.queryClient;
  var _ref2 = useRouter() || {
      query: {
        agent_country: '',
        reservationId: ''
      },
      pathname: '',
      asPath: ''
    },
    query = _ref2.query,
    pathname = _ref2.pathname,
    asPath = _ref2.asPath;
  var isGuestAccountEnabled = useFeatureSwitch({
    featureSwitchKey: FS_DISPLAY_GUEST_ACCOUNT
  });
  var isAgentMemoEnabled = !!query.reservationId || !!query.tempBasketReference || !!query.tempBookingReference;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useAgentMemo = useAgentMemo(),
    openAgentMemo = _useAgentMemo.openAgentMemo,
    isAgentMemoOpen = _useAgentMemo.isAgentMemoOpen,
    setAgentMemoReservationId = _useAgentMemo.setAgentMemoReservationId,
    agentMemoCount = _useAgentMemo.agentMemoCount,
    closeAgentMemo = _useAgentMemo.closeAgentMemo;
  var agentCountry = query['agent_country'];
  var currentLang = agentCountry !== null && agentCountry !== void 0 ? agentCountry : language;
  var isWindowDefined = typeof window !== 'undefined';
  var basketReference = String((query === null || query === void 0 ? void 0 : query.reservationId) || (query === null || query === void 0 ? void 0 : query.tempBasketReference) || (query === null || query === void 0 ? void 0 : query.tempBookingReference) || '');
  var bookingReference = query !== null && query !== void 0 && query.bookingReference ? String(query.bookingReference) : '';
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    origin = _useState2[0],
    setOrigin = _useState2[1];
  useEffect(() => {
    setOrigin(window.location.origin);
  }, [isWindowDefined]);
  useEffect(() => {
    var referenceId = query.reservationId || query.tempBasketReference || query.tempBookingReference;
    if (referenceId) {
      setAgentMemoReservationId(referenceId);
    } else {
      closeAgentMemo();
    }
  }, [query.reservationId, query.tempBasketReference, query.tempBookingReference]);
  var isManager = roles === null || roles === void 0 ? void 0 : roles.includes(UserRoles.MANAGER);
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      language,
      country,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    data = _useQueryRequest.data;
  var _useFeatureToggle = useFeatureToggle(),
    isUniquePromoCodeEnabled = _useFeatureToggle[FT_CCUI_UNIQUE_PROMO_CODE];
  var isPromoAdminUser = isPromoAdmin(user);
  var isPromoCodeEnabled = isUniquePromoCodeEnabled && isPromoAdminUser;
  var agentDisabledLinks = isGuestAccountEnabled ? [] : [data === null || data === void 0 || (_data$headerInformati = data.headerInformation) === null || _data$headerInformati === void 0 || (_data$headerInformati = _data$headerInformati.content) === null || _data$headerInformati === void 0 || (_data$headerInformati = _data$headerInformati.menu) === null || _data$headerInformati === void 0 ? void 0 : _data$headerInformati.guestAccount];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showChangeLogModal = _useState4[0],
    setShowChangeLogModal = _useState4[1];
  var regex = /\/amend/;
  var isAmendPage = regex.test(pathname);
  var isChangeLogEnabled = isAmendPage && bookingReference;
  var enableModal = showChangeLogModal && bookingReference;
  var handleChangeLogClicked = useCallback(() => {
    setShowChangeLogModal(true);
  }, []);
  var countries = (_data$headerInformati2 = data === null || data === void 0 || (_data$headerInformati3 = data.headerInformation) === null || _data$headerInformati3 === void 0 || (_data$headerInformati3 = _data$headerInformati3.content) === null || _data$headerInformati3 === void 0 ? void 0 : _data$headerInformati3.countries) !== null && _data$headerInformati2 !== void 0 ? _data$headerInformati2 : [];
  var languagesList = getListOfLanguagesForSwitcher(countries);
  var _useHotelBrands = useHotelBrands({
      basketReference,
      channel: Channel.Ccui,
      queryClient
    }),
    brand = _useHotelBrands.brand;
  var routeManager = route => {
    switch (route) {
      case 'discoverPI':
        return '/';
      case 'findBooking':
        return "/".concat(country, "/").concat(currentLang, "/bookings");
      case 'guestAccount':
        return "/".concat(country, "/").concat(currentLang, "/search-account");
      case 'changeLogs':
        return '/';
      case 'promoCode':
        return "/".concat(country, "/").concat(currentLang, "/unique-promotions/list");
      default:
        return '/';
    }
  };
  var navigationLinks = Object.keys(HeaderLinks).map(item => {
    var _data$headerInformati4;
    var menuResponse = data === null || data === void 0 || (_data$headerInformati4 = data.headerInformation) === null || _data$headerInformati4 === void 0 || (_data$headerInformati4 = _data$headerInformati4.content) === null || _data$headerInformati4 === void 0 ? void 0 : _data$headerInformati4.menu;
    if (item === 'promoCode' && !isPromoCodeEnabled) {
      return null;
    }
    if (menuResponse && Object.keys(menuResponse).length > 0 && Object.keys(menuResponse).includes(item)) {
      return {
        key: item,
        text: menuResponse[item],
        url: routeManager(item)
      };
    }
  });
  var router = useRouter() || {};
  useEffect(() => {
    if (agentCountry) {
      delete query['agent_country'];
      var copyAsPath;
      if (asPath.indexOf("&agent_country=".concat(agentCountry)) !== -1) {
        copyAsPath = asPath.replace("&agent_country=".concat(agentCountry), '');
      } else if (asPath.indexOf("agent_country=".concat(agentCountry, "&")) !== -1) {
        copyAsPath = asPath.replace("agent_country=".concat(agentCountry, "&"), '');
      } else {
        copyAsPath = asPath.replace("?agent_country=".concat(agentCountry), '');
      }
      router.push({
        pathname,
        query
      }, copyAsPath, {
        locale: agentCountry
      });
    }
  }, [agentCountry, router]);
  var navStyle = language === 'en' ? stackStyle : stackStyleDE;
  var textStyle = language === 'en' ? linkStyle : linkStyleDE;
  var tickIcon = _jsx(Icon, {
    src: formatAssetsUrl(data === null || data === void 0 || (_data$headerInformati5 = data.headerInformation) === null || _data$headerInformati5 === void 0 || (_data$headerInformati5 = _data$headerInformati5.content) === null || _data$headerInformati5 === void 0 || (_data$headerInformati5 = _data$headerInformati5.menu) === null || _data$headerInformati5 === void 0 ? void 0 : _data$headerInformati5.tick),
    color: "var(--chakra-colors-primary)"
  });
  var containerWrapperStyles = () => {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxW: 'var(--chakra-space-breakpoint-xl)',
      h: 'full',
      pl: language === 'en' ? {
        mobile: 'md',
        xs: '5',
        sm: 'md',
        md: 'lg',
        lg: '4.125rem'
      } : {
        mobile: 'md',
        xs: '5',
        sm: 'md',
        md: 'lg',
        lg: '1.75rem',
        xl: '4.125rem'
      },
      pr: language === 'en' ? {
        mobile: 'md',
        md: '1.688rem',
        lg: '4.125rem'
      } : {
        mobile: 'md',
        md: '1.688rem',
        lg: '1.75rem',
        xl: '4.125rem'
      }
    };
  };
  var handleSessionItem = key => {
    if (pathname !== '/bookings' && key === 'findBooking') {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('SearchBookingFormBookingReference', JSON.stringify(''));
        window.sessionStorage.removeItem('ccuiPrevSearchCriteria');
      }
    }
  };
  function applyDisabledStyles(isDisabled) {
    return isDisabled ? textStyleDisabled : {};
  }
  var subNav = data === null || data === void 0 || (_data$headerInformati6 = data.headerInformation) === null || _data$headerInformati6 === void 0 || (_data$headerInformati6 = _data$headerInformati6.content) === null || _data$headerInformati6 === void 0 ? void 0 : _data$headerInformati6.subNav;
  return _jsxs(Box, _objectSpread(_objectSpread({}, headerWrapperStyles), {}, {
    "data-testid": "common-header-wrapper",
    children: [_jsx(Container, _objectSpread(_objectSpread({}, containerWrapperStyles()), {}, {
      children: _jsxs(Grid, _objectSpread(_objectSpread({}, contentStyles), {}, {
        sx: {
          '@media print': {
            py: 'sm'
          }
        },
        children: [_jsx(Flex, _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
          "data-testid": "logo-container",
          children: _jsx(Logo, {
            src: formatAssetsUrl(data === null || data === void 0 || (_data$headerInformati7 = data.headerInformation) === null || _data$headerInformati7 === void 0 ? void 0 : _data$headerInformati7.content.header.image),
            href: "".concat(origin, "/").concat(country, "/").concat(language),
            isHeaderLogo: true,
            variant: currentLang === 'de' && brand !== 'hub' && brand !== 'zip' ? 'pi-simple' : brand,
            transform: "scale(1)"
          })
        })), _jsx(Grid, {
          templateColumns: "1fr auto",
          display: {
            mobile: 'none',
            lg: 'grid'
          },
          sx: {
            '@media print': {
              display: 'none'
            }
          },
          children: _jsxs(Stack, _objectSpread(_objectSpread({
            as: "nav"
          }, navStyle), {}, {
            children: [_jsx(Box, _objectSpread(_objectSpread({}, languageSelectorWrapperStyles), {}, {
              children: _jsx(LanguageSelectorSwitcher, {
                currentLanguage: currentLang,
                tickIcon: tickIcon,
                languagesList: languagesList,
                area: Area.CCUI
              })
            })), navigationLinks.filter(elem => elem).map(link => {
              var _link$url, _link$key, _link$key2, _subNav$1$navOptions, _subNav$, _subNav$2$navOptions, _subNav$2, _subNav$3$navOptions, _subNav$3;
              var isLinkDisabled = false;
              var isPopoverLinkEnabled = false;
              isLinkDisabled = agentDisabledLinks.includes(link === null || link === void 0 ? void 0 : link.text);
              var disabledLinkStyle = applyDisabledStyles(isLinkDisabled);
              isPopoverLinkEnabled = (link === null || link === void 0 ? void 0 : link.key) === 'discoverPI';
              return _jsx(Box, {
                children: !isPopoverLinkEnabled ? _jsx(NextLink, {
                  href: (_link$url = link === null || link === void 0 ? void 0 : link.url) !== null && _link$url !== void 0 ? _link$url : '',
                  passHref: true,
                  legacyBehavior: true,
                  children: _jsx(Link, _objectSpread(_objectSpread({
                    onClick: () => handleSessionItem(link === null || link === void 0 ? void 0 : link.key)
                  }, _objectSpread(_objectSpread({}, noBoxShadowStyle), disabledLinkStyle)), {}, {
                    children: _jsx(Text, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, textStyle), disabledLinkStyle)), {}, {
                      "data-testid": formatDataTestId('navigation-link', link === null || link === void 0 || (_link$key = link.key) === null || _link$key === void 0 ? void 0 : _link$key.replace(/ /g, '_')),
                      children: link === null || link === void 0 ? void 0 : link.text
                    }))
                  }))
                }) : _jsx(Popover, {
                  triggerItem: _jsx(Box, _objectSpread(_objectSpread({}, textStyle), {}, {
                    children: _jsx(Link, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, noBoxShadowStyle), disabledLinkStyle)), {}, {
                      children: _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, textStyle), {}, {
                        "data-testid": formatDataTestId('popover-enabler-text', link === null || link === void 0 || (_link$key2 = link.key) === null || _link$key2 === void 0 ? void 0 : _link$key2.replace(/ /g, '_'))
                      }, disabledLinkStyle), {}, {
                        children: link === null || link === void 0 ? void 0 : link.text
                      }))
                    }))
                  })),
                  children: _jsxs(Flex, {
                    "data-testid": "HeaderAgent-entire-popover-DiscoverPI",
                    justifyContent: "flex-end",
                    children: [renderListItems((_subNav$1$navOptions = (_subNav$ = subNav[1]) === null || _subNav$ === void 0 ? void 0 : _subNav$.navOptions) !== null && _subNav$1$navOptions !== void 0 ? _subNav$1$navOptions : [], subNav[1].title, 'discoverPIfirstColumn'), renderListItems((_subNav$2$navOptions = (_subNav$2 = subNav[2]) === null || _subNav$2 === void 0 ? void 0 : _subNav$2.navOptions) !== null && _subNav$2$navOptions !== void 0 ? _subNav$2$navOptions : [], subNav[2].title, 'discoverPISecondColumn'), renderListItems((_subNav$3$navOptions = (_subNav$3 = subNav[3]) === null || _subNav$3 === void 0 ? void 0 : _subNav$3.navOptions) !== null && _subNav$3$navOptions !== void 0 ? _subNav$3$navOptions : [], subNav[3].title, 'discoverPIThirdColumn')]
                  })
                })
              }, link === null || link === void 0 ? void 0 : link.text);
            }), _jsx(Link, _objectSpread(_objectSpread({
              onClick: handleChangeLogClicked
            }, _objectSpread(_objectSpread({}, noBoxShadowStyle), applyDisabledStyles(!isChangeLogEnabled))), {}, {
              children: _jsx(Text, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, textStyle), applyDisabledStyles(!isChangeLogEnabled))), {}, {
                "data-testid": "navigation-link-changeLogs",
                children: data === null || data === void 0 || (_data$headerInformati8 = data.headerInformation) === null || _data$headerInformati8 === void 0 || (_data$headerInformati8 = _data$headerInformati8.content) === null || _data$headerInformati8 === void 0 || (_data$headerInformati8 = _data$headerInformati8.menu) === null || _data$headerInformati8 === void 0 ? void 0 : _data$headerInformati8.changeLogs
              }))
            }), "changeLog"), _jsx(Link, _objectSpread(_objectSpread({
              href: "#"
            }, _objectSpread(_objectSpread({}, noBoxShadowStyle), applyDisabledStyles(!isAgentMemoEnabled))), {}, {
              onClick: e => {
                e.preventDefault();
                if (!isAgentMemoEnabled) return;
                var referenceId = query.reservationId || query.tempBasketReference || query.tempBookingReference;
                openAgentMemo(MemoModalVariants.PAGE);
                setAgentMemoReservationId(referenceId);
              },
              children: _jsxs(Box, _objectSpread(_objectSpread({}, agentLinkContainerStyles), {}, {
                children: [_jsx(Text, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread(_objectSpread({}, linkStyle), applyDisabledStyles(!isAgentMemoEnabled)), isAgentMemoOpen && _objectSpread({}, agentMemoOpenStyle))), {}, {
                  "data-testid": "navigation-link-agentMemo",
                  children: data === null || data === void 0 || (_data$headerInformati9 = data.headerInformation) === null || _data$headerInformati9 === void 0 || (_data$headerInformati9 = _data$headerInformati9.content) === null || _data$headerInformati9 === void 0 || (_data$headerInformati9 = _data$headerInformati9.menu) === null || _data$headerInformati9 === void 0 ? void 0 : _data$headerInformati9.agentMemo
                })), !!agentMemoCount && isAgentMemoEnabled && _jsx(Circle, _objectSpread(_objectSpread({}, agentLinkMemoCountCircleStyles), {}, {
                  children: _jsx(Text, _objectSpread(_objectSpread({}, agentLinkMemoCountTextStyles), {}, {
                    children: agentMemoCount
                  }))
                }))]
              }))
            }), "agentMemo"), _jsx(Link, _objectSpread(_objectSpread({
              href: "/auth/logout"
            }, noBoxShadowStyle), {}, {
              children: _jsx(Text, _objectSpread(_objectSpread({}, linkStyle), {}, {
                "data-testid": "navigation-link-logout",
                children: data === null || data === void 0 || (_data$headerInformati0 = data.headerInformation) === null || _data$headerInformati0 === void 0 || (_data$headerInformati0 = _data$headerInformati0.content) === null || _data$headerInformati0 === void 0 || (_data$headerInformati0 = _data$headerInformati0.authentication) === null || _data$headerInformati0 === void 0 ? void 0 : _data$headerInformati0.logoutButton
              }))
            }), "log-out")]
          }))
        }), _jsx(Grid, {
          display: {
            mobile: 'grid',
            lg: 'none'
          },
          justifyContent: 'end',
          children: "Mobile navigation"
        })]
      }))
    })), enableModal && _jsx(ChangeLog, {
      showChangeLogModal: showChangeLogModal,
      setShowChangeLogModal: setShowChangeLogModal,
      bookingReference: bookingReference
    })]
  }));
  function renderListItems(list, heading, dataTestId) {
    return _jsxs(List, _objectSpread(_objectSpread({
      "data-testid": dataTestId
    }, listStyles), {}, {
      children: [heading && _jsx(Heading, _objectSpread(_objectSpread({}, headingStyles), {}, {
        children: t(heading)
      })), list.map((item, index) => {
        var _item$url;
        return _createElement(ListItem, _objectSpread(_objectSpread({}, listItemStyles), {}, {
          key: index,
          "data-testid": "".concat(dataTestId, "_listItemPopover-").concat(index)
        }), _jsx(Link, {
          href: (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '/',
          target: "_blank",
          children: _jsx(Text, _objectSpread(_objectSpread({}, linkPopoverStyles), {}, {
            children: t(item.title)
          }))
        }));
      })]
    }));
  }
}
var agentLinkContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 'sm'
};
var agentLinkMemoCountTextStyles = {
  fontSize: 'lg',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  lineHeight: 'lg'
};
var agentLinkMemoCountCircleStyles = {
  size: '32px',
  bg: 'darkGrey3',
  color: 'baseWhite'
};
var languageSelectorWrapperStyles = {
  mr: {
    xl: '4rem'
  }
};
var headerWrapperStyles = {
  w: 'full',
  bg: 'white',
  boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-lightGrey2)',
  h: {
    mobile: 'var(--chakra-space-4xl)',
    lg: 'var(--chakra-space-6xl)'
  },
  zIndex: 1010
};
var headingStyles = {
  _focusVisible: {
    outline: 'none'
  },
  fontSize: 'md',
  lineHeight: 3,
  mb: 'sm',
  fontWeight: 'semibold'
};
var contentStyles = {
  w: 'full',
  templateColumns: 'auto 1fr',
  alignItems: 'center'
};
var containerLogoStyle = {
  justifyContent: 'center',
  alignItems: 'center'
};
var linkStyle = {
  fontSize: 'lg',
  lineHeight: 3,
  fontWeight: 'medium',
  textAlign: 'center',
  color: 'darkGrey1'
};
var linkPopoverStyles = {
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline'
  },
  _focusVisible: {
    outline: 'none'
  }
};
var linkStyleDE = {
  fontSize: 'lg',
  lineHeight: 3,
  fontWeight: 'medium',
  textAlign: 'center',
  maxWidth: '160px',
  color: 'darkGrey1'
};
var textStyleDisabled = {
  color: 'lightGrey3',
  pointerEvents: 'none',
  textDecoration: 'none'
};
var stackStyle = {
  direction: 'row',
  spacing: {
    lg: 'xl',
    xl: '3xl'
  },
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 'var(--chakra-space-xl)'
};
var stackStyleDE = {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 7
};
var noBoxShadowStyle = {
  _focus: {
    boxShadow: 'none'
  }
};
var agentMemoOpenStyle = {
  fontWeight: '700'
};
var listItemStyles = {
  w: '48',
  mb: '1',
  _focusVisible: {
    outline: 'none'
  },
  _hover: {
    a: {
      textDecoration: 'underline'
    }
  }
};
var listStyles = {
  w: '48',
  mr: '5',
  color: 'darkGrey1'
};